var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraggableIconInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(-1746 518)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3802",
    "data-name": "Path 3802",
    d: "M5,2A3,3,0,0,0,2,5V46a3,3,0,0,0,3,3H46a3,3,0,0,0,3-3V5a3,3,0,0,0-3-3H5M5,0H46a5,5,0,0,1,5,5V46a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z",
    transform: "translate(1746 -518)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171",
    "data-name": "Rectangle 171",
    width: 19,
    height: 19,
    rx: 3,
    transform: "translate(1751 -513)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    width: 19,
    height: 19,
    rx: 3,
    transform: "translate(1773 -513)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3803",
    "data-name": "Path 3803",
    d: "M2,0H4A1,1,0,0,1,4,2H2A1,1,0,0,1,1.587.048.961.961,0,0,1,1.721.039.99.99,0,0,1,2,0ZM8,0h2a1,1,0,0,1,0,2H8A1,1,0,0,1,8,0Zm6,0h2a1,1,0,0,1,0,2H14a1,1,0,0,1,0-2Zm4,.928a1,1,0,0,1,1,.926c0,.015,0,.031,0,.046v0h0v.038h0V1.95h0v.008h0v0h0v.008h0v0h0v0h0v0h0v0h0v0h0s0,0,0,0h0V3.858a1,1,0,1,1-2,0V2A1,1,0,0,1,17.928.93Zm0,5.93a1,1,0,0,1,1,1v2a1,1,0,0,1-2,0v-2A1,1,0,0,1,18,6.858Zm0,6a1,1,0,0,1,1,1v2a1,1,0,0,1-2,0v-2A1,1,0,0,1,18,12.858Zm-.833,4.128a.961.961,0,0,1,.954.841,1.04,1.04,0,0,1-.854,1.156H15.284a1,1,0,1,1,0-2H17A1,1,0,0,1,17.167,16.986ZM9.284,17h2a1,1,0,0,1,0,2h-2a1,1,0,0,1,0-2Zm-6,0h2a1,1,0,0,1,0,2h-2a1,1,0,1,1,0-2Zm-3.26.266a1.007,1.007,0,0,0,.02.153q-.006-.026-.011-.053v-.014q0-.028-.009-.056v-.011l0-.019ZM1,14.426a1,1,0,0,1,1,1V17H2l-1.976.264A.993.993,0,0,1,.045,17H0V15.426A1,1,0,0,1,1,14.426Zm0-6a1,1,0,0,1,1,1v2a1,1,0,0,1-2,0v-2A1,1,0,0,1,1,8.426Zm0-6a1,1,0,0,1,1,1v2a1,1,0,0,1-2,0v-2A1,1,0,0,1,1,2.426ZM1.731.018a1.009,1.009,0,0,0-.144.03,1.007,1.007,0,0,0-.145.031L1.524.057h.044q.07-.015.141-.026h.022ZM1.441.079h0Z",
    transform: "translate(1773 -491)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    width: 19,
    height: 19,
    rx: 3,
    transform: "translate(1751 -491)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 19,
    height: 19,
    rx: 3,
    transform: "translate(1783 -481)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraggableIconInactive);
export default __webpack_public_path__ + "static/media/draggable-icon-inactive.40b42024b06b3fad616875b258b0120a.svg";
export { ForwardRef as ReactComponent };